<template>
<div class="checkoutSyncCtn" :class="{ 'checkoutSyncCtn--loading': loading }">
    <div class="checkoutSyncCtn__loadingCtn">
        <div class="checkoutSyncCtn__loading" v-if="loading"><img src="/img/loading.gif"></div>
    </div>
    <v-runtime-template v-if="template" :template="template" />
</div>
</template>



<script>
import VRuntimeTemplate from 'v-runtime-template'
import EventBus from '../../EventBus.vue'

export default {


    /* Settings
    --------------------------------------------------------- */

    name: 'CheckoutSyncContainer',

    components: {
        VRuntimeTemplate,
    },

    props: {
    },

    data() {
        return {
            url: window.location.href,
            loading: false,
            template: '',
        }
    },




    /* Life Cycle
    --------------------------------------------------------- */

    created() {
        EventBus.$on('cart-update', (data) => {
            this.loadHtml(this.url)
        })
    },


    mounted() {
        this.loadHtml(this.url)
    },




    /* Data Handling
    --------------------------------------------------------- */

    computed: {
    },


    watch: {
        //
    },




    /* Methods
    --------------------------------------------------------- */

    methods: {
        loadHtml(url) {
            const h = new Headers()
            h.append('X-Requested-With', 'XMLHttpRequest')
            h.append('Cache-Control', 'no-store')
            h.append('Pragma', 'no-cache')
            h.append('Expires', '0')

            const fetchOptions = {
                headers     : h,
                credentials : 'same-origin',
            }

            this.loading = true

            fetch(url, fetchOptions)
                .then(r => r.text())
                .then((html) => {
                    this.template = html
                    this.$nextTick(() => {
                        setTimeout(() => APP.Layout.initComps(), 0)
                        this.loading = false
                    })
                })
        },
    },


}

</script>
